// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Formal criteria for a task submission
 */
export interface TaskFormalCriteriaOutput {
  wordcount: unknown;
  wordcountTolerance: unknown;
  citations?: unknown;
}
